// src/data/regulators/nursing.js

import { regulatorDetails } from "../regulatorDetails";

export const nursingRegulators = {
  Ontario: {
    "Registered Nurse": regulatorDetails.CNO,
    "Registered Practical Nurse": regulatorDetails.CNO,
    "Nurse Practitioner": regulatorDetails.CNO,
  },

  Alberta: {
    "Registered Nurse": regulatorDetails.CRNA,
    "Licensed Practical Nurse": regulatorDetails.CLPHA,
    "Nurse Practitioner": regulatorDetails.CRNA,
    "Registered Psychiatric Nurse": regulatorDetails.CRPNA,
  },

  "British Columbia": {
    "Registered Nurse": regulatorDetails.BCCNM,
    "Licensed Practical Nurse": regulatorDetails.BCCNM,
    "Nurse Practitioner": regulatorDetails.BCCNM,
    "Registered Psychiatric Nurse": regulatorDetails.BCCNM,
  },

  Saskatchewan: {
    "Registered Nurse": regulatorDetails.CRNS,
    "Licensed Practical Nurse": regulatorDetails.SALPN,
    "Nurse Practitioner": regulatorDetails.CRNS,
    "Registered Psychiatric Nurse": regulatorDetails.RPNAS,
  },

  Manitoba: {
    "Registered Nurse": regulatorDetails.CRNM,
    "Licensed Practical Nurse": regulatorDetails.CLPNM,
    "Nurse Practitioner": regulatorDetails.CRNM,
    "Registered Psychiatric Nurse": regulatorDetails.CRPNM,
  },

  Quebec: {
    "Registered Nurse": regulatorDetails.OIIQ,
    "Licensed Practical Nurse": regulatorDetails.OIIAQ,
    "Nurse Practitioner": regulatorDetails.OIIQ,
  },

  "New Brunswick": {
    "Registered Nurse": regulatorDetails.NANB,
    "Licensed Practical Nurse": regulatorDetails.ANBLPN,
    "Nurse Practitioner": regulatorDetails.NANB,
  },

  "Nova Scotia": {
    "Registered Nurse": regulatorDetails.NSCN,
    "Licensed Practical Nurse": regulatorDetails.NSCN,
    "Nurse Practitioner": regulatorDetails.NSCN,
    "Registered Psychiatric Nurse": regulatorDetails.NSCN,
  },

  "Prince Edward Island": {
    "Registered Nurse": regulatorDetails.CRNMPEI,
    "Licensed Practical Nurse": regulatorDetails.CLPNPEI,
    "Nurse Practitioner": regulatorDetails.CRNMPEI,
  },

  "Newfoundland and Labrador": {
    "Registered Nurse": regulatorDetails.CRNNL,
    "Licensed Practical Nurse": regulatorDetails.CLPNNL,
    "Nurse Practitioner": regulatorDetails.CRNNL,
  },

  Yukon: {
    "Registered Nurse": regulatorDetails.YRNA,
    "Licensed Practical Nurse": regulatorDetails.YUKON_PLA,
    "Nurse Practitioner": regulatorDetails.YRNA,
    "Registered Psychiatric Nurse": regulatorDetails.YUKON_PLA,
  },

  "Northwest Territories": {
    "Registered Nurse": regulatorDetails.RNANTNU,
    "Licensed Practical Nurse": regulatorDetails.GNWT_HSS,
    "Nurse Practitioner": regulatorDetails.RNANTNU,
  },

  Nunavut: {
    "Registered Nurse": regulatorDetails.RNANTNU,
    "Licensed Practical Nurse": regulatorDetails.NUNAVUT_HEALTH,
    "Nurse Practitioner": regulatorDetails.RNANTNU,
  },
};